/*
* modal
*/
export default class Modal {
  constructor() {
    this.$modalButtons = document.querySelectorAll('[data-target="modalButton"]');
  }

  attachEvent() {
    Array.prototype.forEach.call( this.$modalButtons, $button => {
      const modalName = $button.getAttribute('data-modal-name');
      const $modalBody = document.querySelector(`[data-modal="${modalName}"]`);

      $button.addEventListener('click', () => {
        $modalBody.classList.remove('is-hide');
        document.body.classList.add('is-modal');
      });

      // モーダル本体をクリックした時のイベントを止める
      this.stopEvent();

      // モーダルを閉じる
      this.close($modalBody);
    });
  }

  stopEvent() {
    const $modalContents = document.querySelectorAll('[data-target="modalContents"]');
    Array.prototype.forEach.call($modalContents, $item => {
      $item.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

  }

  close(target) {
    const $modalClose = document.querySelectorAll('[data-close="modalClose"]');
    Array.prototype.forEach.call($modalClose, $item => {
      $item.addEventListener('click', () => {
        document.body.classList.remove('is-modal');
        target.classList.add('is-hide');
      });
    });
  }
}
